import React from 'react';
import {AppFormLayout,AppForm,AppFormPageProps,AppFormItemEnum} from 'qcc'
import {appEnum} from 'utils/appEnum'

export default class PosBankEditForm extends React.PureComponent<AppFormPageProps> {
    state = {}
    
	render() {
		let {formData,mode,id} = this.props;
		return (<AppFormLayout defaultButton mode={this.props.mode}>
            <AppFormLayout.Form>
                <AppForm entity='pos_device' loadingData={false} mode={mode} keyValue={id} formData={formData} >
                    <AppForm.Section labelWidth={100}>
						<AppForm.Item itemType={AppFormItemEnum.hidden} field='project_id' dataType={appEnum.dataType.number} />
                        <AppForm.Item field='bank_name' itemType={AppFormItemEnum.input} label="入账银行" req readonly={true}  />
						<AppForm.Item field='bank_number' itemType={AppFormItemEnum.input} label="银行账号" req  />
                        <AppForm.Item field='remark' itemType={AppFormItemEnum.input} label="备注" req  />
                    </AppForm.Section>
                </AppForm>
            </AppFormLayout.Form>
        </AppFormLayout>
	    )
	}

}


// WEBPACK FOOTER //
// ./src/page/pos/bank/PosBankEditForm.tsx